export const openAnchorTabMixin = {
  mounted() {
    $(function () {
      Lagina.openAnchorTab();
    });
  },

  methods: {
    openAnchorTab() {
      const _this = this;
      let hash = window.location.hash.substring(1);
      if (hash) $('.nav-tabs a[href="#' + hash + '"]').tab('show');

      $(".nav-tabs a").on("click", function () {
        let hash = $(this).attr("href");
        if (hash) _this.replaceHash(hash);
      });
    },

    replaceHash(newhash) {
      if ('replaceState' in history) { // Yay, supported!
        if (('' + newhash).charAt(0) !== '#') newhash = '#' + newhash;
        history.replaceState('', '', newhash);
        return;
      }

      const hash = location.hash;
      if (location.hash !== hash) history.back();
      location.hash = newhash;
    },
  }
};
